import { render, staticRenderFns } from "./produce.vue?vue&type=template&id=e1047a48&scoped=true"
import script from "./produce.vue?vue&type=script&lang=js"
export * from "./produce.vue?vue&type=script&lang=js"
import style0 from "./produce.vue?vue&type=style&index=0&id=e1047a48&prod&lang=less&scoped=true"
import style1 from "./produce.vue?vue&type=style&index=1&id=e1047a48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1047a48",
  null
  
)

export default component.exports